// @flow

import ErrorManager from './ErrorManager'
/**
 *
 * Strcuture for EsUser which is the author of requests to DMP.
 ** This is mandatory for each request !
 * @class MainEsUser
 */
class MainEsUser {
    EsUser: any

    /**
     * Init empty EsUser
     */
    constructor() {
        this.EsUser = {}
    }

    /**
     * Add medical Healthcare Professional's infos to EsUser
     **  EsUser.HP : { s_name, s_given, s_codeProfession, s_professionOid, s_codeSpecialty, s_internalId, i_authenticationMode }
     */
    initHPInfos(
        authLastName: string,
        authFirstName: string,
        authCodeProfession: string,
        authOidCodeProfession: string,
        authCodeSpeciality: string,
        authInternalId: string,
        authAuthenticationMode: number,
    ) {
        this.EsUser.HP = {
            s_name: authLastName,
            s_given: authFirstName,
            s_codeProfession: authCodeProfession,
            s_professionOid: authOidCodeProfession,
            s_codeSpecialty: authCodeSpeciality,
            s_internalId: authInternalId,
            i_authenticationMode: authAuthenticationMode,
        }
    }

    /**
     * Add practice location infos to EsUser
     **  EsUser.PracticeLocation : { s_name, s_activitySector, s_practiceSettings }
     */
    initPracticeLocationInfos(
        authPracticeLocName: string,
        authPraticeLocSectorCode: string,
        authPracticeSettings: string,
    ) {
        this.EsUser.PracticeLocation = {
            s_name: authPracticeLocName,
            s_activitySector: authPraticeLocSectorCode,
            s_practiceSettings: authPracticeSettings,
        }
    }

    setHPObject(HP: any) {
        this.EsUser.HP = HP
    }

    setPracticeLocationObject(PracticeLocation: any) {
        this.EsUser.PracticeLocation = PracticeLocation
    }

    /**
     * Returns the current EsUser if valid
     */
    checkAndgetEsUser() {
        if (!this.EsUser.HP) {
            ErrorManager.sendError('Missing HP object in EsUser !')
        }

        if (!this.EsUser.PracticeLocation) {
            ErrorManager.sendError('Missing PracticeLocation object in EsUser !')
        }

        return this.EsUser
    }
}

export default MainEsUser
